import { SVGProps } from "react";
import { Icon, IconProps } from "@chakra-ui/react";

export function CopyIcon(props: IconProps) {
  return <Icon as={CopyIconComponent} color="purple.500" boxSize="20px" {...props} />;
}

function CopyIconComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.9993 13.3335H8.33268C7.41221 13.3335 6.66602 12.5873 6.66602 11.6668V5.00016C6.66602 4.07969 7.41221 3.3335 8.33268 3.3335H14.9993C15.9198 3.3335 16.666 4.07969 16.666 5.00016V11.6668C16.666 12.5873 15.9198 13.3335 14.9993 13.3335Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.334 13.3332V14.9998C13.334 15.4419 13.1584 15.8658 12.8458 16.1783C12.5333 16.4909 12.1093 16.6665 11.6673 16.6665H5.00065C4.55862 16.6665 4.1347 16.4909 3.82214 16.1783C3.50958 15.8658 3.33398 15.4419 3.33398 14.9998V8.33317C3.33398 7.89114 3.50958 7.46722 3.82214 7.15466C4.1347 6.8421 4.55862 6.6665 5.00065 6.6665H6.66732"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

  );
}
